import { Signage, signageReload } from '../../../Signage';

/**
 * Enable/disable Reach Video Support (will reload the player)
 *
 * Note: This will only work for platforms that don't natively have support for
 * Reach Videos (i.e. Browser Players).
 * @param enable - set to `true` to enable Reach Video support
 */
export async function setReachVideoSupport(enable: boolean): Promise<void> {
    const platform = Signage.platform;
    const keyName = 'allow_reach_video';
    if (enable) {
        await platform.setNamedValue(keyName, 'yes');
    } else {
        await platform.deleteNamedValue(keyName);
    }
    await signageReload();
}
